
import React from "react"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

import Layout from "../src/components/Layout"
import Post from "../src/components/Post"
import { useSiteMetadata } from '../src/hooks'

import SEO from "../src/components/seo"



import Test from '../pub/pages/test.jsx'



const postTitle = `✉️ Contacts
`

const SecondPage = ({pageContext}) => {
  const { title: siteTitle, subtitle: siteSubtitle } = useSiteMetadata();
  const { item } = pageContext
  return <Layout title={`${postTitle} - ${siteTitle}`} >
    <SEO title={postTitle} />
    <Post PUBDATE={item.PUBDATE} title={postTitle} >
    <h2>You can contact me in the following ways! </h2><ul><li><p>email </p></li><li><p>skype </p></li><ul><li><p>call me! </p></li></ul></ul><Test/>

    </Post>
  </Layout>
}

export default SecondPage
